__turbopack_context__.v({
  "resultsMessageQuery": "results-count-module-scss-module__QmdhVa__resultsMessageQuery",
  "totalResults": "results-count-module-scss-module__QmdhVa__totalResults",
});
